import React from "react";

/**
 * Intercept click events that would trigger navigation in preview mode.
 * Prevents anchor tags from redirecting the host page (e.g. dashboard).
 *
 * Usage: `<div onClickCapture={interceptPreviewClicks}>`
 */
export function interceptPreviewClicks(e: React.MouseEvent) {
  const target = (e.target as HTMLElement).closest("a");
  if (target && target.hasAttribute("href")) {
    e.preventDefault();
    e.stopPropagation();
  }
}
